<template>
  <b-card
    class="p-2 h-100 matched-job-list-item"
    body-class="px-3 pb-0"
    footer-class="bg-white p-2 border-0"
  >
    <!-- title and location -->
    <div class="mt-0">
      <h4 style="font-size: 1.1rem">
        <b>{{ job.title }}</b>
      </h4>
      <p
        v-if="job.location || (job.customFieldsHash && job.customFieldsHash.contract) || job.industry"
        style="font-size: 13px"
        class="mb-2"
      >
        <span v-if="locationText" class="mr-3">
          <font-awesome-icon class="text-muted" icon="map-marker"/> {{ locationText }}
        </span>
        <span v-if="job.customFieldsHash && job.customFieldsHash.contract">
          <font-awesome-icon class="text-muted" icon="clock"/> {{ job.customFieldsHash.contract }}
        </span>
        <span v-if="job.industry">
          <font-awesome-icon class="text-muted" icon="industry"/> {{ job.industry }}
        </span>
      </p>
      <p>{{ job.excerpt.substr(0, 60) }}...</p>
    </div>

    <!-- introduce button -->
    <template slot="footer">
      <div v-if="job.status === 'ACTIVE'">
        <span
          v-if="job.matchesTotal && job.matchesTotal.total && !isRecruiter"
          class="ml-2 mt-2 float-left"
        >You have {{ job.matchesTotal.total | plural('match') }}</span>
        <b-button
          class="float-right px-4"
          variant="primary"
          :to="{ name: 'JobShow', params: { jobID: job.id } }"
        >
          {{ $t('jobs.ctas.item-employee') }}
        </b-button>
      </div>
    </template>
  </b-card>

</template>

<script>
import tinycolor from 'tinycolor2';
import { mapRoot } from '@src/mixins/root';

export default {
  props: {
    job: {
      type: Object,
    },
  },
  computed: {
    ...mapRoot([ 'company', 'user', 'isLoggedIn', 'isRecruiter' ]),
    background() {
      const { siteBranding } = this.company;
      return siteBranding && siteBranding.primaryColour ? tinycolor(siteBranding.primaryColour).lighten(42).toString() : '#eee';
    },
    locationText() {
      const { location } = this.job;
      if (location && location.name) {
        const text = `${location.name}, ${location.countryCode}`;
        return text.length > 20 ? `${text.substr(0, 17)}...` : text;
      }
      return null;
    }
  },
};
</script>

<style lang="scss">
.matched-job-list-item {
  .skill-tag {
    display: inline-block;
    font-size: 13px;
    padding: 3px 6px;
    border-radius: 2px;
  }
  .development-tag {
    position: relative;
    display: inline-block;
    padding: 3px 10px;
    border-radius: 2px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/JobCard.vue